import { useState, useEffect } from "react";
import Spinner from "react-bootstrap/Spinner";
import auth from "../Account/Auth";
import be from "../BE";

function AddMicrosoftCalendar({ callback }) {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    const handleMsRedirect = async () => {
      const qs = window.location.search.substring(1);
      const qsParams = qs.split(["&"]);
      let qsMsCode = qsParams.find((x) => x.startsWith("calmscode="));
      if (qsMsCode) {
        try {
          setLoading(true);
          setError("");
          qsMsCode = qsMsCode.substring(10);
          await auth
            .isAuthenticated()
            .then(async () => {
              await be
                .post(
                  "account-jubilant",
                  "/account/microsoft/calendars",
                  { code: qsMsCode },
                  true,
                  true
                )
                .then(() => {
                  // invoke parent’s refetch
                  callback?.();
                })
                .catch((e) => {
                  console.log(
                    "request catch: error while connecting microsof calendar:",
                    e
                  );
                  setError(e.toString());
                });
            })
            .catch((e) => {
              console.log(
                "Auth catch: autentication error while connecting microsoft calendar:",
                e
              );
            });
          // clear the code from URL without reloading
          window.history.replaceState(null, "", window.location.pathname);
        } catch (e) {
          console.error(
            "functional catch: Error connecting Microsoft Calendar:",
            e
          );
          setError(e.toString());
        } finally {
          setLoading(false);
        }
      }
    };
    handleMsRedirect();
  }, []);

  return (
    <div className="d-inline-block float-end">
      <a
        href="https://login.microsoftonline.com/common/oauth2/v2.0/authorize?client_id=a6b54902-9538-43da-b3ab-1a575cc386e5&state=addCalendar&response_type=code&scope=Calendars.ReadWrite+User.Read.All+offline_access+openid+profile"
        className="tw-flex tw-items-center tw-me-2 tw-h-[38px] tw-bg-[#212529] tw-rounded tw-p-2 tw-gap-2 tw-text-white no-underline"
      >
        <img
          src="/app-assets/img/ms-logo.png"
          width="22"
          height="22"
          alt="Microsoft Calendar"
        />
        <span className="">Add Microsoft Calendar</span>
        {loading && (
          <Spinner animation="border" size="sm" className="tw-ml-2" />
        )}
      </a>
      {error && (
        <small className="tw-block tw-text-red-500 tw-mt-1 lowercase">
          {error}
        </small>
      )}
    </div>
  );
}

export default AddMicrosoftCalendar;
